import { render, staticRenderFns } from "./jinGangTu.vue?vue&type=template&id=1902f9b2&scoped=true&"
import script from "./jinGangTu.vue?vue&type=script&lang=js&"
export * from "./jinGangTu.vue?vue&type=script&lang=js&"
import style0 from "./jinGangTu.vue?vue&type=style&index=0&id=1902f9b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1902f9b2",
  null
  
)

export default component.exports